export default "__VITE_ASSET__CTSWZdSc__"